import { postAzureContractsData } from '../../../api/azure/index'
import { postGCPContractsData } from '../../../api/gcp/index'
import { postContractsData } from '../../../api/marketplace/index'
import type { CloudMarketplace } from '../../productsListing/types'

export const callSendContractsDataAPIBasedOnCloud = async (
  objectToSend: Record<string, unknown>,
  partnerId: string,
  selectedCloudProvider: CloudMarketplace
) => {
  switch (selectedCloudProvider) {
    case 'AWS': {
      return await postContractsData(objectToSend, partnerId)
    }
    case 'AZURE': {
      return await postAzureContractsData(objectToSend, partnerId)
    }
    case 'GCP': {
      return postGCPContractsData(objectToSend, partnerId)
    }
  }
}
